var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between items-center mb-1 text-grayNeutralDark"},[_c('div',{staticClass:"flex items-center gap-1"},[_c('svg',{attrs:{"width":"16","height":"17"}},[_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}})]),_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }